import * as firebase from 'firebase'
require('firebase/firestore')

let config = {
  apiKey: 'AIzaSyCZynScDxhm0tA4mG5rm7iLaUrahXNbnK4',
  authDomain: 'abra-seafarer.firebaseapp.com',
  databaseURL: 'https://abra-seafarer.firebaseio.com',
  projectId: 'abra-seafarer',
  storageBucket: 'abra-seafarer.appspot.com',
  messagingSenderId: '874792623951'
}

export const firebaseApp = firebase.initializeApp(config)

export const db = firebaseApp.firestore()

export const storage = firebaseApp.storage()
export const blankCheques = storage.ref('blankCheques')
export const approvedCheques = storage.ref('approvedCheques')

export const auth = firebaseApp.auth()
export const GoogleLogin = new firebase.auth.GoogleAuthProvider()

export const storageKey = 'KEY_FOR_LOCAL_STORAGE'

export const isAuthenticated = () => {
  return (
    !!auth.currentUser ||
    !!window.localStorage.getItem(storageKey)
  )
}



// WEBPACK FOOTER //
// ./src/firebase.js